import React, { useState, useEffect } from "react";
import "./groups-table-header.styles.scss";
import FiltersPanel from "../../../../../components/filter-panel/filter-panel";
import { Form } from "react-bootstrap";
import ArrowIconDisabled from "../../../../../assets/img/arrow-filter-solid-disabled.svg";
import ArrowIcon from "../../../../../assets/img/arrow-filter-solid.svg";
import FilterIcon from "../../../../../assets/icons/Icon - FilterDisabled.svg";
import FilterIconOn from "../../../../../assets/icons/Icon - Filter.svg";
import {
  selectGroups,
  selectSelectedGroups,
} from "../../../../../redux/groups/group-selector";
import { selectUser } from "../../../../../redux/user/user-selector";
import { setSelectedGroups } from "../../../../../redux/groups/group-actions";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { GetFiltersAPI } from "../../../../../services/api/group-api";

const tableHeaderInfo = [
  {
    name: "GROUP NAME",
    filterName: "Group Name",
    containerClassName: "th-fullname-col",
    hasFilter: true,
    hasSort: true,
    filterType: "GroupsNew",
    sortBy: "Name",
  },
  {
    name: "GROUP DESCRIPTION",
    filterName: "",
    containerClassName: "th-description-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
  {
    name: "CREATED BY",
    filterName: "Created By",
    containerClassName: "th-createdBy-col",
    hasFilter: true,
    hasSort: true,
    filterType: "Creators New",
    sortBy: "CreatedBy",
  },
  {
    name: "GROUP MEMBERS",
    filterName: "Group Members",
    containerClassName: "th-members-col",
    hasFilter: true,
    hasSort: false,
    filterType: "Group Members New",
    sortBy: "",
  },
  {
    name: "GROUP SIZE",
    filterName: "",
    containerClassName: "th-size-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "Size",
  },
  {
    name: "STATUS",
    filterName: "",
    containerClassName: "th-status-col",
    hasFilter: false,
    hasSort: true,
    filterType: "",
    sortBy: "Status",
  },
  {
    name: "ACTIONS",
    filterName: "",
    containerClassName: "th-admin-actions-col",
    hasFilter: false,
    hasSort: false,
    filterType: "",
    sortBy: "",
  },
];

const GroupsTableHeaderNew = ({ refreshPage, changeData, isArchived, setIsArchived }) => {
  const [activeFilterType, setActiveFilterType] = useState("");
  const [activeSortType, setActiveSortType] = useState("");
  const [isDescendingSort, setIsDescendingSort] = useState(false);
  const [selectedFilterRows, setSelectedFilterRows] = useState([]);
  const [filterList, setFilterList] = useState({});

  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const data = useSelector(selectGroups);
  const selectedRows = useSelector(selectSelectedGroups);

  useEffect(() => {
    const getFilters = async () => {
      const filters = await GetFiltersAPI();
      setFilterList((prev) => ({
        ...prev,
        creators: filters?.data?.[2],
        members: filters?.data?.[1],
        groups: filters?.data?.[0],
      }));
    };

    getFilters(); //Fetch filters on mount
  }, []);

  useEffect(() => {
    if (isArchived) {
      const fetchFilters = async () => {
        try {
          const response = await GetFiltersAPI();
          const newFilterList = {
            creators: response?.data?.[2],
            members: response?.data?.[1],
            groups: response?.data?.[0],
          };
          setFilterList(newFilterList);
          const updatedFilterList = newFilterList.groups; // Ensuring filterList is up-to-date before filtering
          const filterRowsNew = selectedFilterRows.filter(row => 
            isRowInUpdatedFilterList(row, updatedFilterList)
          );
          setSelectedFilterRows(filterRowsNew);
          if (filterRowsNew.length === 0) {
            setActiveFilterType("");
          }
          setIsArchived(false);
        } catch (error) {
          console.log("Error fetching filters for group", error);
        }
      };
      fetchFilters(); // Fetch filters when an item from filtered list is archived
    }
  }, [isArchived, filterList, selectedFilterRows, setIsArchived]);
  
  const isRowInUpdatedFilterList = (row, updatedFilterList) => {
    return updatedFilterList.some(group => group.Id === row.Id);
  };

  const onSelectAll = (e) => {
    let tempList = [];
    if (e.target.checked) {
      data.forEach((group) => {
        tempList.push(group.Id);
      });
    }
    dispatch(setSelectedGroups(tempList));
  };

  const passPayload = (label) => {
    switch (label) {
      case "GROUP NAME":
        return filterList?.groups;
      case "CREATED BY":
        return filterList?.creators;
      case "GROUP MEMBERS":
        return filterList?.members;
      default:
        return [];
    }
  };

  const updateFilter = (selectedRows, type) => {
    setSelectedFilterRows(selectedRows);
    setActiveFilterType(type);
  };

  const clearFilter = () => {
    setActiveFilterType("");
    setSelectedFilterRows([]);
    refreshPage();
  };

  const saveFilter = (newFilter) => {
    //Buffer function makes sure we only makes the necessary changes and nothing else
    changeData(newFilter);
  };

  const handleSortClick = (sortType) => {
    //All the sortDesc logic is stored in the search query in UsersTableContainer
    if (activeSortType === sortType && !isDescendingSort) {
      //If sorting by ascending, then turn off on this click
      setActiveSortType("");
      setIsDescendingSort(false);
      changeData(undefined, "Name", false);
      return;
    }

    if (activeSortType !== sortType) {
      // If not sorting yet, just set to sorting
      setActiveSortType(sortType);
      setIsDescendingSort(true);
      changeData(undefined, sortType, true);
      return;
    }

    //Now sorting upwards
    setIsDescendingSort(false);
    changeData(undefined, sortType, false);
  };

  return (
    <thead className="group-table-header">
      <tr>
        <th className="th-checkbox-col">
          <Form.Check
            type={"checkbox"}
            disabled={!user?.privileges["Group"].Delete}
            onClick={(e) => onSelectAll(e)}
            checked={selectedRows.length === data.length && data.length !== 0}
          />
        </th>
        {tableHeaderInfo.map((labelInfo, index) => {
          return (
            <th className={labelInfo.containerClassName} key={index}>
              <div className="th-container">
                {labelInfo.hasFilter && (
                  <div className={`th-icon-filter`}>
                    <FiltersPanel
                      selected={
                        activeFilterType === labelInfo.filterType
                          ? selectedFilterRows
                          : []
                      }
                      filterIcon={
                        activeFilterType === labelInfo.filterType
                          ? FilterIconOn
                          : FilterIcon
                      }
                      header={labelInfo.filterName}
                      type={labelInfo.filterType}
                      updateSelected={updateFilter}
                      save={saveFilter}
                      clear={clearFilter}
                      change={() => {}}
                      close={() => {}}
                      adminPayload={passPayload(labelInfo.name)}
                    ></FiltersPanel>
                  </div>
                )}
                <div className="th-name">{labelInfo.name}</div>
                {labelInfo.hasSort && (
                  <div className="arrow-holder">
                    <img
                      className="th-icon-up"
                      src={
                        activeSortType === labelInfo.sortBy && !isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                      onKeyDown={() => handleSortClick(labelInfo.sortBy)}
                    />
                    <img
                      className="th-icon-down"
                      src={
                        activeSortType === labelInfo.sortBy && isDescendingSort
                          ? ArrowIcon
                          : ArrowIconDisabled
                      }
                      alt="filter-arrow"
                      onClick={() => handleSortClick(labelInfo.sortBy)}
                      onKeyDown={() => handleSortClick(labelInfo.sortBy)}
                    />
                  </div>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

GroupsTableHeaderNew.propTypes = {
  refreshPage: PropTypes.func.isRequired,
  changeData: PropTypes.func.isRequired,
  isArchived: PropTypes.bool.isRequired,
  setIsArchived: PropTypes.func.isRequired,
};

export default GroupsTableHeaderNew;
